import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CallbackEmails = ({ code }: { code: string }) => {
  const navigate = useNavigate();

  const getOutlookAccessToken = async () => {
    // const tenantId = ";
    const tokenUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/token`; // Token endpoint
    const clientId = ""; // Your Client ID
    const clientSecret = ""; // Your Client Secret
    const redirectUri = ''; // Redirect URI

    // Prepare POST request body
    const body = new URLSearchParams();
    body.append("client_id", clientId);
    body.append("client_secret", clientSecret);
    body.append("code", code); // The authorization code
    body.append("redirect_uri", redirectUri);
    body.append("grant_type", "authorization_code"); // Grant type for code exchange
    body.append("scope", "openid profile Mail.Read Mail.Send"); // Scopes

    // Send POST request to get the access token
    const response = await fetch(tokenUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded", // Content type for token request
      },
      body: body,
    });

    // Parse the response
    const data = await response.json();

    if (data.access_token) {
      window.localStorage.setItem("outlook_access_token", data.access_token);
	  navigate('/settings');
      return data.access_token; // Return the access token
    } else {
      throw new Error("Failed to retrieve access token");
    }
  };

  const fetchGoogleAccessToken = async () => {
		const tokenEndpoint = 'https://oauth2.googleapis.com/token';
		const clientId =
		  '';
		const clientSecret = '';
		const redirectUri = '';
		const grantType = 'authorization_code';
		try {
		  const response = await fetch(tokenEndpoint, {
			method: 'POST',
			headers: {
			  'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams({
				code,
				client_id: clientId,
				client_secret: clientSecret,
				redirect_uri: redirectUri,
				grant_type: grantType,
			  }),
		  });
		  const data = await response.json();
		  if (response.ok) {
			const accessToken = data.access_token;
	
			localStorage.setItem('google_access_token', accessToken);
			navigate('/purchase-orders');
		  } else {
			console.error(
			  'Error:',
			  data.error_description || 'Error occurred during token exchange'
			);
		  }
		} catch (err: any) {
		  console.error('Error:', err);
		}
  };

  useEffect(() => {
    getOutlookAccessToken();
  }, []);

  return <></>;
};

export default CallbackEmails;
